<template>
  <div>
    <partnerBranch
      :partners="partners"
      :subPartners="subPartners"
      :partnerBranches="partnerBranches"
      @getpartnerBranches="getpartnerBranches"
    />
  </div>
</template>

<script>
import partnerBranch from "@/components/link/branch.vue";

export default {
  components: { partnerBranch },
  data() {
    return {
      partnerBranches: [],
      subPartners: [],
      partners: [],
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Partner Branches" }]);
    this.initialise();
  },
  methods: {
    async initialise() {
      await Promise.all([
        this.getpartnerBranches(),
        this.getSubPartners(),
        this.getPartners(),
      ]);
    },
    async getpartnerBranches() {
      await this.$axios
        .get("partner_branches")
        .then((res) => {
          this.partnerBranches = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPartners() {
      await this.$axios
        .get("partners")
        .then((res) => {
          this.partners = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getSubPartners(partner_id) {
      await this.$axios
        .get("sub_partners", { params: { partner_id } })
        .then((res) => {
          this.subPartners = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
  },
};
</script>

<style></style>
